// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_3Tk1j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Illustrations/Illustrations.scss
// module id = 846
// module chunks = 0